




















import { Component, Vue, Prop } from "vue-property-decorator";
// import { Company, Office } from "@/api/company-api";

import VDelete from "../../../components/VDelete.vue";
import SwitchButton from "@/components/SwitchButton.vue";
// import SelectOption from "@/common/ui/presenters/select-option";
import { CsvDate } from "../../api/csv-date-api";
@Component({
  components: {
    VDelete,
    SwitchButton
  },
  props: {
    removable: {
      type: Boolean,
      default: false
    }
  }
})
export default class CsvDateEdit extends Vue {
  @Prop({ required: true }) CsvDate!: CsvDate;

  status = "";

  submit() {
    this.status = "progressing";
    this.$emit("ok");
  }

  cancel() {
    this.$emit("cancel");
  }

  remove() {
    this.$emit("remove");
  }
}
